<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-plus"
        texto-titulo="Nueva Categoria"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Datos:</h5>
                  <form @submit.prevent="guardarCategoria()">
                    <float-label label="Código:" clase>
                      <input
                        v-model="categoria.codigo"
                        id="codigo"
                        placeholder="Ingresar un código..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.categoria.codigo.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.categoria.codigo.required"
                        >
                          Debe ingresar un código
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Descripción:" clase="">
                      <input
                        id="descripcion"
                        v-model="categoria.descripcion"
                        placeholder="Ingresar una descripción..."
                        type="text"
                        class="form-control"
                      />
                    </float-label>
                    <button class="mt-1 btn btn-info float-right">
                      Guardar
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import { required } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import Categoria from "@/models/categoria";
import axios from "axios";
export default {
  name: "NuevaCategoria",
  components: {
    TituloComponente,
    FloatLabel,
  },
  data() {
    return {
      categoria: new Categoria(null, "", ""),
    };
  },
  validations: {
    categoria: {
      codigo: { required },
      descripcion: { required },
    },
  },
  methods: {
    guardarCategoria() {
      axios
        .post("/categorias", this.categoria)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarCategorias" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      console.log(this.categoria);
    },
  },
};
</script>